<template lang="pug">
div
    modal(v-show="isShowModal_",:titulo="'NUEVA ' + nameModulo.toUpperCase()" bindClass="col-md-4 col-sm-12" , @close="isShowModal_=false")
        div(slot='body')  
            .form-group
                .form-row
                    .col-md-12.col-sm-12
                        label Nombre de Usuario
                        input.form-control.form-control-sm(v-model="parameter.NameUser", @keypress.enter="sendInfo()") 
                .form-row
                    .col-md-12.col-sm-12
                        label Email
                        input.form-control.form-control-sm(v-model="parameter.Email")
                .form-row
                    .col-md-12.col-sm-12
                        label Contraseña
                        input.form-control.form-control-sm(v-model="parameter.Password", type="password")
                .form-row
                    .col-md-12.col-sm-12
                        label Cargo
                        input.form-control.form-control-sm(v-model="parameter.Position") 
                
        div(slot='footer')
            button.btn.btn-primary(@click="sendInfo()") Guardar
</template>
<script>
import modal from "../../../complementos/modal.vue"
import toolValidate from '../../../tools/validate.js'
export default {
    props:{ 
        nameModulo:String,
        IsShowModal:Boolean,
        parameter:Object
    },  
    components:{
        modal
    },
    computed:{
        isShowModal_ :{
                        get(){return this.IsShowModal },
                        set(val){this.$emit("update:IsShowModal",val)}
        }
    },
    methods:{ 
            sendInfo(){
                this.parameter.TypeAccount=6
                this.parameter.IsResponsible=2
                if(this.validate()){
                    this.$emit("update:parameter",this.parameter)
                    this.$emit("sendInfo",this.parameter)
                }       
            },
            validate(){ 
                console.log(this.parameter.IdEnterprise)
                if(this.parameter.IdEnterprise=='0' || this.parameter.IdEnterprise=='' || this.parameter.IdEnterprise==null ){
                    this.$msgbox.show("No Hay Empresa Selecionada o Cargada","Alerta")
                    return false
                } 
                else if(this.parameter.NameUser=='' || this.parameter.NameUser==null ){
                    this.$msgbox.show("Ingrese Nombre de Usuario","Alerta")
                    return false
                } 
                else if(this.parameter.Email=='' || this.parameter.Email==null ){
                    this.$msgbox.show("Ingrese Email","Alerta")
                    return false
                }
                else if(this.parameter.Password=='' || this.parameter.Password==null ){
                    this.$msgbox.show("Ingrese Contraseña","Alerta")
                    return false
                }
                else if(this.parameter.TypeAccount=='' || this.parameter.TypeAccount==null ){
                    this.$msgbox.show("Selecione Tipo de Cuenta","Alerta")
                    return false
                }
                else{
                    return true
                }
            }
    }

    
}
</script>